import { Action } from '@ngrx/store';

export interface TravellerInfoResponse {
  travellers: number[];
  travellers_names: string[];
  travellers_documents_requirements: any[];
}
export const RESET_TRAVEL_BOOKING = '[Travel Booking] Reset travel booking';

export const CREATE_TRAVEL_BOOKING = '[Travel Booking] Create travel booking';
export const CREATE_TRAVEL_BOOKING_SUCCESS = '[Travel Booking] Create travel booking success';
export const CREATE_TRAVEL_BOOKING_ERROR = '[Travel Booking] Create travel booking error';

export class ResetTravelBooking implements Action {
  readonly type = RESET_TRAVEL_BOOKING;
}

export class CreateTravelBooking implements Action {
  readonly type = CREATE_TRAVEL_BOOKING;
  constructor(public payload: any) {}
}

export class CreateTravelBookingSuccess implements Action {
  readonly type = CREATE_TRAVEL_BOOKING_SUCCESS;
  constructor(public payload: any) {}
}

export class CreateTravelBookingError implements Action {
  readonly type = CREATE_TRAVEL_BOOKING_ERROR;
  constructor(public payload: any) {}
}

export type TravelBookingActions =
  | ResetTravelBooking
  | CreateTravelBooking
  | CreateTravelBookingSuccess
  | CreateTravelBookingError;
